module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_5012.eb9d4dc8.png";